import { PREFIX_URL_API } from '@/shared/constants';
import { apiClient } from '@/shared/utils/apiClient';

import type { IApiResponseMailSubscriptionJoin, TApiMailSubscriptionJoin } from './types';

export const joinApi: TApiMailSubscriptionJoin = (postData) => {
  const url = `${PREFIX_URL_API.API}/MailSubscription/MailSubscriptionApi`;
  return apiClient.post<IApiResponseMailSubscriptionJoin>(url, postData);
};
